export default __webpack_public_path__ + "static/CasualPatron-e6764d44c5d54ed8b162be0ae4f01c84.png";